module.exports = __webpack_public_path__ + "img/wx_tip1.94eabada.png";